import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/app/components/Header.tsx");
